<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 24 14"
>
  <path
    [attr.fill]="color"
    d="M12.015 2C16.766 2 20.078 5.012 21.519 6.636C20.118 8.473 16.806 12 12.015 12C7.595 12 4.085 8.464 2.537 6.593C4.03 4.946 7.354 2 12.015 2ZM12.015 0C4.446 0 0 6.551 0 6.551C0 6.551 4.835 14 12.015 14C19.748 14 24 6.551 24 6.551C24 6.551 19.709 0 12.015 0ZM12 3C9.791 3 8 4.792 8 7C8 9.209 9.791 11 12 11C14.209 11 16 9.209 16 7C16 4.792 14.209 3 12 3Z"
  ></path>
</svg>